<template>
  <div class="member-invite-enter-details">
    <div class="header-container">
      <img class="header-background" :src="require('@/assets/round-header-background.svg')">
      <div class="title-container">
        <div class="title">הוזמנת לתזרים משותף עם {{ primaryMemberDetails.firstName }}, כי ביחד קל יותר לנצח את החודש!</div>
      </div>
    </div>

    <div class="content">
      <div class="ask-details">לפני שנמשיך נצטרך כמה פרטים:</div>
      <enter-details :action="generateCodeAndProceed"
                        :error="errors.generateCode"
                        :reset-error="() => resetError('generateCode')"/>

      <div class="promise">אנחנו מבטיחים לא למסור את הפרטים שלך לאף צד שלישי.</div>

      <support-footer />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../../Segment';
import EnterDetails from '../../../../../base-components/EnterDetails.vue';

export default {
  name: 'MemberInviteEnterDetails',
  components: {
    EnterDetails,
    SupportFooter: BaseUI.SupportFooter,
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('MemberInviteEnterDetailsEntered');
  },
  computed: {
    ...mapState('memberInvite', ['errors']),
    ...mapState('inviteSession', ['primaryMemberDetails']),
  },
  methods: {
    ...mapMutations('memberInvite', ['setFirstName', 'setLastName', 'setPhoneNumber', 'resetError']),
    ...mapActions('memberInvite', ['generateCode']),
    async generateCodeAndProceed(firstName, lastName, phoneNumber) {
      await this.setFirstName(firstName);
      await this.setLastName(lastName);
      await this.setPhoneNumber(phoneNumber);
      await this.generateCode();
      this.next();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .member-invite-enter-details {
    font-family: SimplerPro;
    width: 100%;

    .header-container {
      position: relative;
      text-align: center;

      .header-background {
        width: 100%;
      }

      .title-container {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        height: 100%;
        align-items: center;

        .title {
          display: inline-block;
          @include title;
          line-height: 32px;
          padding: 0 20px;
        }
      }
    }

    .content {
      margin: 0 30px;

      .ask-details {
        margin: 40px 0;
        font-size: 20px;
      }

      .promise {
        margin: 24px 0 18px 0;
        line-height: 22px;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/invite-authenticated/member-invite/pages/MemberInviteEnterDetails.vue